import { makeNodeId } from '../../../../DolEditor/withNodeId';

export const normalizeNodeShouldHaveId = (node) => {
  if (node && !node.id && node.type) {
    node = {
      ...node,
      id: makeNodeId(),
    };
  }

  return node;
};
